import { GraphQlClient, Storage } from '@intelipost-js/secure-providers';
import { ScToast } from '@intelipost-js/secure-components';

export default {
  getIsValidDeliveryMethodRecote({ commit }, config) {
    commit('setLoading', true);
    const { id, idDeliveryMethod } = config;

    if (id && idDeliveryMethod) {
      const params = {
        id,
        idDeliveryMethod,
      };

      return GraphQlClient.query(`
      query(
        $id: String,
        $idDeliveryMethod: Int
      ) {
        requote(
          id: $id
          idDeliveryMethod: $idDeliveryMethod
        ) {
          isValid
        }
      }`, params)
        .then((response = {}) => {
          const res = response;
          const { data = {} } = res;
          commit('setLoading', false);
          const isValid = data.requote.isValid;
          if (!isValid) {
            ScToast.danger('Este método não está mais disponível para atual cotação');
          }
          return Promise.resolve(isValid);
        })
        .catch((err) => {
          commit('setLoading', false);
          return Promise.reject(err);
        });
    }

    return Promise.reject();
  },

  getQuotations({ commit }, config) {
    commit('setLoading', true);

    const {
      filters = null,
      pagination = null,
      sorting = {},
    } = config;

    if (filters && pagination) {
      const params = {
        search_by: filters.search_by,
        search_value: filters.search_value,
        created_after: filters.created_after,
        page: pagination.page,
        limit: pagination.limit,
        sort_direction: sorting.direction,
        sort_field: sorting.column,
      };

      return GraphQlClient.query(`
      query(
        $search_by: String,
        $search_value: String,
        $created_after: Date,
        $page: Int,
        $limit: Int,
        $sort_direction: String,
        $sort_field: String
      ) {
        quotations(
          search_by: $search_by
          search_value: $search_value
          created_after: $created_after
          page: $page
          limit: $limit
          sort_direction: $sort_direction
          sort_field: $sort_field
        ) {
          total
          hasNextPage
          items {
            id
            origin_zip_code
            destination_zip_code
            created
            logistic_provider {
              delivery_methods {
                name
                cost
                removed_by_quote_rules
                removed_by_return_modes
                final_shipping_cost
                delivery_estimate_business_days
                delivery_estimate_minutes
              }
            }
            order {
              volumes {
                weight
                width
                height
                length
              }
            }
            delivery_methods_debug {
              name
              restriction_messages
              is_inactive
            }
          }
        }
      }`, params)
        .then((response = {}) => {
          const res = response;
          const { data = {} } = res;
          const { quotations = {} } = data;
          if (quotations.items) {
            quotations.items = quotations.items.map((item) => {
              const debug_filtered =
                item.delivery_methods_debug.filter(debug => !debug.is_inactive);
              return {
                ...item,
                delivery_options_debug: debug_filtered,
              };
            });
          }
          commit('setQuotations', quotations);
          commit('setLoading', false);
          return Promise.resolve(res);
        })
        .catch((err) => {
          commit('setLoading', false);
          return Promise.reject(err);
        });
    }

    return Promise.reject();
  },
  getQuotation({ commit, dispatch }, { id, show_error }) {
    commit('setLoading', true);

    return GraphQlClient.query(`
    query(
      $id: ID!
      $show_error: Boolean
    ){
      quotation(
        id: $id
        show_error: $show_error
      ){
        id
        origin_zip_code
        destination_zip_code
        created
        platform
        order{
          volumes{
            type
            width
            height
            length
            weight
            cost_of_goods
          }
        }
        logistic_provider{
          delivery_methods{
            id
            type
            name
            description
            logo_url
            cost
            final_shipping_cost
            delivery_estimate_business_days
            removed_by_quote_rules
            removed_by_return_modes
            delivery_estimate_minutes
            delivery_estimate_minutes_to_day
            delivery_estimate_date_minutes
            delivery_estimate_date_minutes_iso
          }
        }
        delivery_methods_debug {
          name
          restriction_messages
          delivery_method_name,
          logistic_provider_name,
          delivery_method_type,
          final_shipping_cost,
          final_delivery_time,
          delivery_estimate_business_days,
          is_removed_by_api_return_mode,
          is_removed_by_quote_rule,
          cost,
          is_inactive,
          freight{
            delivery_estimate_minutes
            delivery_estimate_minutes_to_day
            delivery_estimate_date_minutes
            delivery_estimate_date_minutes_iso
          },
        }
      }
    }`, { id, show_error })
      .then((res = {}) => {
        const { data = {} } = res;
        const delivery_options_debug =
          data.quotation.delivery_methods_debug.filter(item => !item.is_inactive);
        const quotation = {
          ...data.quotation,
          delivery_options_debug,
        };
        commit('setQuotation', quotation);
        commit('setLoading', false);
        const {
          origin_zip_code,
          destination_zip_code,
          order,
        } = quotation;

        const new_origin_zip_code = origin_zip_code.length < 8
          ? origin_zip_code.padStart(8, '0')
          : origin_zip_code;

        const new_destination_zip_code = destination_zip_code.length < 8
          ? destination_zip_code.padStart(8, '0')
          : destination_zip_code;


        Storage.set('currentQuote', {
          origin_zip_code: new_origin_zip_code,
          destination_zip_code: new_destination_zip_code,
          volumes: order.volumes.map((volume) => {
            const volume_type = volume.type
                  ? volume.type.value
                  : '';
            return Object.assign(volume, { volume_type });
          }),
        });
      })
      .catch((error) => {
        commit('setLoading', false);
        dispatch('getQuote', id);
        return error;
      });
  },
  getQuote({ commit }, id) {
    commit('setLoading', true);

    return GraphQlClient.query(`
    query(
      $id: ID!
    ){
      quotationNew(
        id: $id
      ){
        id
        origin_zip_code
        destination_zip_code
        created
        platform
        order{
          volumes{
            type
            width
            height
            length
            weight
            cost_of_goods
          }
        }
        logistic_provider{
          delivery_methods{
            id
            type
            name
            description
            logo_url
            cost
            final_shipping_cost
            delivery_estimate_business_days
            removed_by_quote_rules
            removed_by_return_modes
          }
        }
        delivery_methods_debug {
          name
          restriction_messages
          delivery_method_name,
          logistic_provider_name,
          delivery_method_type,
          final_shipping_cost,
          delivery_estimate_business_days,
          is_removed_by_api_return_mode,
          is_removed_by_quote_rule,
          cost,
          is_inactive,
          freight{
            delivery_estimate_minutes
            delivery_estimate_minutes_to_day
            delivery_estimate_date_minutes
            delivery_estimate_date_minutes_iso
          },
        }
      }
    }`, { id })
      .then(({ data }) => {
        const { quotationNew } = data || {};
        const delivery_options_debug =
        quotationNew.delivery_methods_debug.filter(item => !item.is_inactive);
        const quotation = {
          ...quotationNew,
          delivery_options_debug,
        };
        commit('setQuotation', quotation);
        commit('setLoading', false);
        const {
          origin_zip_code,
          destination_zip_code,
          order,
        } = quotationNew;

        const new_origin_zip_code = origin_zip_code.length < 8
          ? origin_zip_code.padStart(8, '0')
          : origin_zip_code;

        const new_destination_zip_code = destination_zip_code.length < 8
          ? destination_zip_code.padStart(8, '0')
          : destination_zip_code;


        Storage.set('currentQuote', {
          origin_zip_code: new_origin_zip_code,
          destination_zip_code: new_destination_zip_code,
          volumes: order.volumes.map((volume) => {
            const volume_type = volume.type
                  ? volume.type.value
                  : '';
            return Object.assign(volume, { volume_type });
          }),
        });
      })
      .catch((err) => {
        commit('setLoading', false);
        return Promise.reject(err);
      });
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-quote/features/quotations/store/actions.js